import type { DetailPageContext, ListingPageContext, PageRootContext } from '#layers/block-engine/public';
import { createBlockRootContextProperty } from '#layers/block-engine/public';

const pageTypeBlockRootContext = createBlockRootContextProperty<PageRootContext['pageType']>('pageType');
const collectionIdBlockRootContext = createBlockRootContextProperty<DetailPageContext['collectionId'] | ListingPageContext['collectionId']>('collectionId');
const itemIdBlockRootContext = createBlockRootContextProperty<DetailPageContext['itemId']>('itemId');

/**
 * Reads page type values from registered root renders.
 */
export const consumePageTypeBlockRootContext = pageTypeBlockRootContext.consume;

/**
 * Reads collection id values from registered root renders.
 */
export const consumeCollectionIdBlockRootContext = collectionIdBlockRootContext.consume;

/**
 * Reads item id values from registered root renders.
 */
export const consumeItemIdBlockRootContext = itemIdBlockRootContext.consume;
